import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="docs-menu"
export default class extends Controller {
  connect() {
  }

  clickCollapse(event) {
    const frame = document.getElementById('docs_content')
    frame.src = event.target.href
  }
}
